<template>
	<div style="text-align: center;">
		<h2 style="margin-bottom: 30px;">请用微信扫码二维码注册账号</h2>
		<vue-qr ref="qrcode" :text="qrtext" :size="600" color="#333" bg-color="#fff"></vue-qr>
	</div>
</template>

<script>
	
	import VueQr from 'vue-qr'

	export default {
		name: 'Register',
		components: {
			VueQr
		},

		data() {
			return {
				qrtext:"https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe767b997d8d79600&redirect_uri=http%3A%2F%2Fsyllh5.zaoxiang.wang&response_type=code&scope=snsapi_base&state=P!_!102657!_!00#wechat_redirect"
			}
		},

		methods: {


		}
	}
</script>

<style scoped>
</style>